import React, { useEffect } from 'react';
import './adjudicacion.css';

const Adjudicacion = ({ ciclo, adjudicacion }) => {
    useEffect(() => {
       window.scrollTo(0, 0);
    },
     []);

    const appAnteriores = adjudicacion;

    const click1 = ( procedimiento ) => {
        var aux = document.getElementById( procedimiento ).style;
            aux.display = aux.display === 'block' ? 'none': "block";
    }

    return (    
        <div className='container'>
            <div className='row'>
                <div className='rubros_titulo'>
                    <h2>Procedimientos de Invitación a Cuando Menos Tres Personas {ciclo}</h2>
                </div>               
                <div>                  
                    { appAnteriores.map((item, index)=>( 
                        <>
                            <div className='convocatoria'>
                                {/*<a href="#" onClick={ () => click1 (item.numInvitacion)} >*/}
                                {/*    <div className="numconvocatoria">*/}
                                {/*        <h4 className="tituloConvoca">{item.numInvitacion}</h4>    */}
                                {/*    </div>*/}
                                {/*</a>*/}
                                <button onClick={() => click1(item.numInvitacion)}>
                                    <div className="numconvocatoria">
                                        <h4 className="tituloConvoca">{item.numInvitacion}</h4>
                                    </div>
                                </button>
                                <div class="licitacion" id={item.numInvitacion} style={{display: 'none'}}>
                                    {item.procedimiento.map((item1, index1) => (
                                            <div>
                                                <h5 className="numlicitacion">{item1.numProc}</h5>
                                                <h6 className="vigencia">{item1.vigenciaProc}</h6>
                                                <div className="contenido">
                                                    <div className="descripcionApp">
                                                        <p className="nombrelicita">{item1.descripcionProc}</p>
                                                    </div>
                                                    <div className="descargaAnexosApp">
                                                        <p>Dictamen de viabilidad</p>
                                                        <a class="actas" target='_blank' rel="noopener noreferrer" href={item1.urlDictamen}><i class="fas fa-download icodescarga"></i></a>
                                                    </div>
                                                    <div className="descargaAnexosApp">
                                                        <p>Convocatoria y Bases</p>
                                                        <a class="actas" href={item1.urlAnexos}><i class="fas fa-download icodescarga"></i></a>
                                                    </div>
                                                    <div className="resultadosApp">
                                                        <p class="encabezado">Resultados</p>
                                                        {item1.resultadosProc.map((item2, index2) => (
                                                            <>
                                                                <div><a href={item2.urlResultado} target='_blank'>{item2.resultado}</a></div>
                                                            </>))}
                                                    </div>
                                                </div>
                                                <hr class="separador"></hr>
                                            </div>
                                        )
                                    )}

                                </div>
                            </div>
                        </>
                    ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Adjudicacion